import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IBlankslate } from 'codex-lib';
import { Authorizer } from '../../../model/authorizer';
import { CheckboxState } from 'src/app/enum/checkbox-state';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { NewEnvelopeService } from '../../new-envelope/new-envelope.service';
import { LanguageUtil } from 'src/app/util/language-util';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-authorizer-table',
  templateUrl: './authorizer-table.component.html',
  styleUrls: ['./authorizer-table.component.scss']
})
export class AuthorizerTableComponent implements OnInit {

  @Output() checkAllClick = new EventEmitter();
  @Output() elementClick = new EventEmitter();
  @Output() cleanSearchClick = new EventEmitter();

  @Input() elements: Array<Authorizer>;
  @Input() headerCheckboxState: CheckboxState;
  blankslateOptions: IBlankslate;
  checkboxState = CheckboxState;
  hiddenPhoneColumn: boolean;

  constructor(
    private authService: AuthService,
    private newEnvelopeService: NewEnvelopeService) {
    if (!this.authService.signUserModel) {
      return;
    }

    this.hiddenPhoneColumn = !this.authService.signUserModel.sendWhatsapp;
  }

  ngOnInit() {
    this.blankslateOptions = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };
  }

  onHeaderCheckboxChange() {
    this.checkAllClick.emit();
  }

  onCheckboxClick(el) {
    this.elementClick.emit(el);
  }

  onBlankSlateButtonClick() {
    this.cleanSearchClick.emit();
  }

  setMaskValue(value) {
    return CPFCNPJUtil.formatSsn(value);
  }

  isShowSSN() {
    const languageId = this.newEnvelopeService.getLanguageEnvelope();
    return LanguageUtil.isCurrentLanguagePT(languageId) ? true : false;
  }
}
